import {
  Factory,
  type ID,
  type NodeItem,
  ProjectActions,
  selectBlocksByNode,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import { getId } from '@store/utils'
import { commitProjectRequest } from '@storeOld/actionCreators'
import { setLastAddedBlockId } from '@storeOld/reducers/canvas/canvas'
import { put, select } from 'redux-saga/effects'

export function* addBlockByPageContent() {
  const { ui }: AppState = yield select()

  const { nodeId } = ui.modalProps

  if (!nodeId) {
    return
  }

  const node: NodeItem = yield select(
    migrationProjectSelector.getProjectNodeById(nodeId)
  )

  if (!node) {
    return
  }

  const { colorId } = node

  const blocksByNodeId: ID[] = yield select(selectBlocksByNode(nodeId))
  const index = blocksByNodeId.length

  const id = getId()
  const block = Factory.block.monolithic({
    id,
    colorId,
  })

  yield put(
    commitProjectRequest(
      ProjectActions.blocks.add({
        items: [block],
        index,
        parents: [nodeId],
      })
    )
  )

  yield put(setLastAddedBlockId(id))
}
